export enum StateAidCertificateType {
  Credit = 'credit',
  Leasing = 'leasing',
}

export type TStateAidReceivedQuarterDto = {
  year: number;
  quarter: number;
  amountMmsp?: number;
  periodMmsp?: string;
  institutionMmsp?: string;
  amountGroup?: number;
  periodGroup?: string;
  institutionGroup?: string;
};

export type TStateAidReceivedQuarterFormValues = {
  year: number;
  quarter: number;
  amountMmsp: string;
  periodMmsp: string;
  institutionMmsp: string;
  amountGroup: string;
  periodGroup: string;
  institutionGroup: string;
};

export type TStateAidCertificateDto = {
  documentDate?: string;
  companyFullName?: string;
  companyIdentifier?: string;
  receivedAidQuarters?: TStateAidReceivedQuarterDto[];
  apprAmountMmsp?: number;
  apprApplicationDateMmsp?: string;
  apprApprovalDateMmsp?: string;
  apprPlannedPeriodMmsp?: string;
  apprInstitutionMmsp?: string;
  apprAmountGroup?: number;
  apprApplicationDateGroup?: string;
  apprApprovalDateGroup?: string;
  apprPlannedPeriodGroup?: string;
  apprInstitutionGroup?: string;
  reqAmountMmsp?: number;
  reqApplicationDateMmsp?: string;
  reqInstitutionMmsp?: string;
  reqAmountGroup?: number;
  reqApplicationDateGroup?: string;
  reqInstitutionGroup?: string;
  covidAmountMmsp?: number;
  covidApplicationDateMmsp?: string;
  covidInstitutionMmsp?: string;
  covidAmountGroup?: number;
  covidApplicationDateGroup?: string;
  covidInstitutionGroup?: string;
  exportSales?: boolean;
  idpStatus?: boolean;
  veteranStatus?: boolean;
  disabilityStatus?: boolean;
  agricultural?: boolean;
  cultivatedArea?: number;
  signerPosition?: string;
  signerFullName?: string;
};

export type TStateAidCertificateResponse = {
  type: 'STATE_AID_RECEIVED' | 'MMSP_STATE_AID_RECEIVED';
  body: TStateAidCertificateDto | null;
  version: number;
  fullName?: string;
  borrowerEdrpou?: string;
  fop: boolean;
};

export type TStateAidFormValues = {
  documentDate: string | Date | null;
  companyFullName: string;
  companyIdentifier: string;
  receivedAidQuarters: TStateAidReceivedQuarterFormValues[];
  apprAmountMmsp: string;
  apprApplicationDateMmsp: string;
  apprApprovalDateMmsp: string;
  apprPlannedPeriodMmsp: string;
  apprInstitutionMmsp: string;
  apprAmountGroup: string;
  apprApplicationDateGroup: string;
  apprApprovalDateGroup: string;
  apprPlannedPeriodGroup: string;
  apprInstitutionGroup: string;
  reqAmountMmsp: string;
  reqApplicationDateMmsp: string;
  reqInstitutionMmsp: string;
  reqAmountGroup: string;
  reqApplicationDateGroup: string;
  reqInstitutionGroup: string;
  covidAmountMmsp: string;
  covidApplicationDateMmsp: string;
  covidInstitutionMmsp: string;
  covidAmountGroup: string;
  covidApplicationDateGroup: string;
  covidInstitutionGroup: string;
  exportSales: boolean;
  idpStatus: boolean;
  veteranStatus: boolean;
  disabilityStatus: boolean;
  agricultural: boolean;
  cultivatedArea: string;
  signerPosition: string;
  signerFullName: string;
};
